import Vue from 'vue'
import Vuex from 'vuex'
// import createVuexAlong from 'vuex-along'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeNav: "",
    showSmsPopup: false,
  },
  mutations: {
    openSmsPopup(state) {
      state.showSmsPopup = true;
    },
    closeSmsPopup(state) {
      state.showSmsPopup = false;
    },
  },
  actions: {
  },
  modules: {
  },
  // plugins: [createVuexAlong()]
})
